import { useCubeQuery } from '@/components/display/use-cube-query';
import { LineItem } from 'shared/src/api/line-item-types';
import { z } from 'zod';
import {
  billableRevenueQuery,
  BillableRevenueResult,
  DailyRevenueSpend
} from 'shared/src/cube-queries/billable-revenue-query';

export function useLineItemBillableRevenue(lineItem: LineItem): BillableRevenueResult {
  const result = useCubeQuery(billableRevenueQuery(lineItem.id));

  if (result.status === 'success') {
    return {
      rows: z.array(DailyRevenueSpend).parse(result.rows),
      isLoading: false,
      error: undefined
    };
  }
  if (result.status === 'error') {
    return { rows: [], isLoading: false, error: result.error };
  }
  return { rows: [], isLoading: true, error: undefined };
}
